export default __webpack_public_path__ + "maps-examples-tracking-mode-1200-109418a17fed5a8d7758bab057394d98.webp";